<template>
	<div class="fondoModal">
		<div>
			<div>
				<div class="card">
					<div class="card-header">
						Descargar auditoría de radiación
						<button type="button" class="close" aria-label="Close" @click="cerrar">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="card-body bg-info text-white">
						<h4>Selecciona las opciones que deseas incluír en el informe</h4>
					</div>
					<div class="card-body text-left">
						<h3>
							<span class="fa fa-list"></span>
							Listados
						</h3>
						<div class="row mt-3">
							<div class="col text-center">
								<b>Programación</b><br>
								<img src="./iconos/listado.png" style="margin:10px;border:1px solid #e0e0e0; border-radius: 3px; cursor:pointer;width:120px;height:120px;" alt="" :style="(form.verProgramacion) ? {opacity: 1} : {opacity:0.2}" @click="form.verProgramacion = !form.verProgramacion">
							</div>
							<div class="col text-center">
								<b>Emisión</b><br>
								<img src="./iconos/listado.png" style="margin:10px;border:1px solid #e0e0e0; border-radius: 3px; cursor:pointer;width:120px;height:120px;" alt="" :style="(form.verEmision) ? {opacity: 1} : {opacity:0.2}" @click="form.verEmision = !form.verEmision">
							</div>
						</div>


					</div>
					<div class="card-body bg-light text-left">
						<h3 style="display:none;">
							<span class="fa fa-bar-chart"></span>
							Estadísticas
						</h3>

						<div class="row mt-3" style="display:none;">
							<div class="col text-center">
								<b>Globales</b><br>
								<img src="./iconos/globales.png" style="margin:10px;border:1px solid #e0e0e0; border-radius: 3px; cursor:pointer;width:120px;height:120px;" alt="" :style="(form.verStatsProgreso) ? {opacity: 1} : {opacity:0.2}" @click="form.verStatsProgreso = !form.verStatsProgreso">
							</div>
							<div class="col text-center">
								<b>Por horas</b><br>
								<img src="./iconos/horas.png" style="margin:10px;border:1px solid #e0e0e0; border-radius: 3px; cursor:pointer;width:120px;height:120px;" alt="" :style="(form.verStatsHoras) ? {opacity: 1} : {opacity:0.2}" @click="form.verStatsHoras = !form.verStatsHoras">
							</div>
							<div class="col text-center">
								<b>Presencia en antena</b><br>
								<img src="./iconos/presencia.png" style="margin:10px;border:1px solid #e0e0e0; border-radius: 3px; cursor:pointer;width:120px;height:120px;" alt="" :style="(form.verStatsPresencia) ? {opacity: 1} : {opacity:0.2}" @click="form.verStatsPresencia = !form.verStatsPresencia">
							</div>
						</div>

						<button class="btn btn-block btn-primary mt-2" @click="generar()" v-if="!generando && haySeleccion">
							<span class="fa fa-gear"></span>
							Generar informe
						</button>

						<div class="progress" v-if="generando">
							<div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
						</div>

						<div v-if="link">
							<hr>
							<h5>Informe listo</h5>
							<form action="/src/modulos/produccion/php/api/get-programacion-pdf.php" method="POST">
								<input type="hidden" name="d" :value="link">
								<button class="btn btn-block btn-success" typ="submit">
									<span class="fa fa-download"></span>
									Descargar
								</button>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import API from '../../services/api'

export default {
	name: 'modal-descargar',
	props: ['idfichero', 'idversion'],

	data: function () {
		return {
			form: {
				verListado: false,
				verProgramacion: false,
				verEmision: false,
				verEstadisticas: false,
				verStatsProgreso: false,
				verStatsHoras: false,
				verStatsPresencia: false
			},
			link: null,
			generando: false
		}
	},

	computed: {
		haySeleccion () {
			for (let i in this.form) {
				if (this.form[i]) {
					return true
				}
			}
		}
	},

	methods: {
		generar () {
			this.form.verListado = (this.form.verProgramacion || this.form.verEmision)
			this.form.verEstadisticas = (this.form.verStatsPresencia || this.form.verStatsProgreso || this.form.verStatsHoras)

			const datos = {
				ID_fichero: this.idfichero,
				ID_version: this.idversion,
				data: this.form
			}

			this.link = null
			this.generando = true

			API.getProgramacionPDF(datos)
				.then(res => {
					this.link = res.data.link
					this.generando = false
				})
				.catch(e => {
					this.$store.commit('alertas/alert', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
					this.generando = false
				})
		},

		descargar () {
			window.location.href = this.link
		},

		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/produccion/vue/components/auditor/modal-descargar.vue